/* # =================================================================
# 上に戻るボタン制御
# ================================================================= */
export default function goTop(scrollTrigger) {
	const goTopElement = document.querySelector('#goTop');
	// エレメントが存在しない場合は早期に処理を終了
	if (!goTopElement) return;

	window.addEventListener('scroll', () => {
		if (window.pageYOffset > scrollTrigger) {
			goTopElement.classList.add('show');
		} else {
			goTopElement.classList.remove('show');
		}
	});
}
